/**
 * Represents the status of an OAuth provider configuration
 */
export class OAuthProviderStatus {
  /**
   * Provider name (e.g., "Jira", "Office365")
   */
  provider: string;

  /**
   * Indicates if the provider is configured for the data owner
   */
  isConfigured: boolean;

  /**
   * Indicates if the provider is active and should be shown
   */
  isActive: boolean;

  /**
   * Indicates if there is a valid (non-expired) token
   */
  hasValidToken: boolean;

  /**
   * Token expiration date (if present)
   */
  tokenExpiresAt?: Date;

  /**
   * Refresh token expiration date
   */
  refreshTokenExpiresAt?: Date;

  /**
   * Indicates if reauthorization is required
   */
  requiresReauthorization: boolean;

  /**
   * Authorization URL in case reauthentication is required
   */
  authorizationUrl: string;

  /**
   * State parameter for CSRF protection (if reauthorization is required)
   */
  state: string;

  /**
   * Reason why the token is not valid or requires reauthorization
   */
  reason: string;

  constructor(data?: Partial<OAuthProviderStatus>) {
    this.provider = data?.provider || '';
    this.isConfigured = data?.isConfigured || false;
    this.isActive = data?.isActive !== undefined ? data.isActive : true;
    this.hasValidToken = data?.hasValidToken || false;
    this.tokenExpiresAt = data?.tokenExpiresAt ? new Date(data.tokenExpiresAt) : undefined;
    this.refreshTokenExpiresAt = data?.refreshTokenExpiresAt ? new Date(data.refreshTokenExpiresAt) : undefined;
    this.requiresReauthorization = data?.requiresReauthorization || false;
    this.authorizationUrl = data?.authorizationUrl || '';
    this.state = data?.state || '';
    this.reason = data?.reason || '';
  }
}

/**
 * Represents the OAuth authorization response
 */
export class OAuthAuthorizeResponse {
  /**
   * URL to redirect the user for authorization
   */
  authorizationUrl: string;

  /**
   * State parameter for CSRF protection
   */
  state: string;

  constructor(data?: Partial<OAuthAuthorizeResponse>) {
    this.authorizationUrl = data?.authorizationUrl || '';
    this.state = data?.state || '';
  }
}